/* himedi-addons-ab.js — test arm of the "addons-on-builder" A/B test, builder page only (2026-10-07).
 * The arm is decided by the inline script in snippets/himedi-addons-ab.liquid (window.HimediAB).
 * In the test arm this fills #cf-addons with the add-on page's own rows (snippets/himedi-addon-groups,
 * kept in <template id="cfAbAddonGroups">) and wires them with the add-on page's own function,
 * HimediFlow.wireAddons() — whole-row tap, focus-area cover lock and footer total are that code, not a copy.
 *
 * wireAddons() deletes the rows of the base that is not selected, so a base switch (Baseline <-> Whole
 * Body MRI) re-renders the list from the template. A focus-area change re-runs wireAddons() on the rows
 * in place, which re-applies the "already included in your Cancer focus area" lock.
 *
 * Control arm, a missing HimediFlow, or a page that is not the builder: does nothing.
 * Revert: delete the render line in himedi-checkup-chrome.liquid (this file is then never loaded).
 */
(function () {
  'use strict';
  var AB = window.HimediAB;
  if (!AB || AB.step !== 1) return;

  function start() {
    var F = window.HimediFlow;
    var region = document.getElementById('cf-addons');
    var tpl = document.getElementById('cfAbAddonGroups');
    var host = region && region.querySelector('.cf-ab-rows');
    if (!F || typeof F.wireAddons !== 'function' || typeof F.baseKey !== 'function' || !region || !tpl || !host) return;

    var base = null;
    function render() {
      base = F.baseKey();
      host.textContent = '';
      host.appendChild(document.importNode(tpl.content, true));
      F.wireAddons();
      region.classList.add('cf-ab-filled');
    }
    function refresh() {
      if (F.baseKey() !== base) render(); else F.wireAddons();
    }
    render();

    // After the flow file's own handlers (they sit on the elements; this listens at the document).
    document.addEventListener('click', function (e) {
      if (e.target.closest && e.target.closest('.baseopt, .upcard, .inc-go')) setTimeout(refresh, 0);
    });
    document.addEventListener('keydown', function (e) {
      if ((e.key === 'Enter' || e.key === ' ') && e.target.closest && e.target.closest('.baseopt, .upcard')) setTimeout(refresh, 0);
    });

    // Forwarded from the old add-ons page (/pages/checkup-addons -> /pages/checkup-build#cf-addons).
    // Content above (fonts, images, the booking banner) can still move after the first scroll, so the region
    // is re-pinned at window load and once more - but never after the visitor has scrolled themselves.
    if (location.hash === '#cf-addons') {
      var lastY = null;
      var pin = function () {
        if (lastY !== null && Math.abs(window.pageYOffset - lastY) > 4) return;
        lastY = Math.max(0, Math.round(region.getBoundingClientRect().top + window.pageYOffset - 84));
        window.scrollTo(0, lastY);
      };
      requestAnimationFrame(pin);
      if (document.readyState === 'complete') setTimeout(pin, 300);
      else window.addEventListener('load', function () { pin(); setTimeout(pin, 600); });
    }
  }

  function go() { AB.onArm.push(function (arm) { if (arm === 'test') start(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
